// fetchRiskPreflight.js
'use strict';
import fetch from '../resource/customFetch.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import handleFetchError from '../resource/handleFetchError.js';
import getMeData from '../selector/getMeData.js';
import getTranslationKey from '../resource/getTranslationKey.js';
import {
  MERGE_OPERATION_DATA,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

const NETWORKING_SELECT_PATH = ['risk-check', 'preflight'];

/**
 * Read-only risk preflight via GET /risk-check/preflight (no fingerprint sent).
 * Writes preflightState and preflightErrorKey to operation. Both 'blocked' and
 * 'error' block checkout (see checkRiskGate); 'required' tells the caller to
 * run the full risk-check next.
 *
 *   GET /risk-check/preflight ─┬─ 'pass'     ──► preflightState 'pass'
 *                              ├─ 'blocked'  ──► preflightState 'blocked'
 *                              ├─ 'required' ──► preflightState 'required'
 *                              └─ error / non-200 ──► preflightState 'error' (+ errorKey)
 *
 * @see https://api.docs.swag.live/#tag/security/operation/risk_check_preflight__get
 * @kind action
 * @return {Promise} Action promise.
 */
const fetchRiskPreflight = () => async (dispatch, getState) => {
  const token = getMeData(getState(), 'token');
  if (!token) return dispatch({ type: '' });

  const fetchUrl = getResourceUrl({ endpoint: '/risk-check/preflight' });
  const fetchOptions = {
    method: 'GET',
    headers: {
      ...getHeaders(),
      Authorization: `Bearer ${token}`,
    },
  };

  let preflightState = 'error';
  let errorKey = '';
  dispatch({
    type: SET_NETWORKING_FETCHING,
    payload: { selectPath: NETWORKING_SELECT_PATH },
  });
  try {
    let response = await fetch(fetchUrl.href, fetchOptions);
    if (!response.ok) {
      response = await handleFetchError({
        response,
        dispatch,
        getState,
        fetchOptions,
        fetchUrl,
      });
    }
    const data = await response.json();
    preflightState = data?.state || 'error';
    dispatch({
      type: SET_NETWORKING_SUCCESS,
      payload: { selectPath: NETWORKING_SELECT_PATH },
    });
  } catch (error) {
    dispatch({
      type: SET_NETWORKING_ERROR,
      payload: { selectPath: NETWORKING_SELECT_PATH, error },
    });
    try {
      errorKey = getTranslationKey({ key: JSON.parse(error.message).code });
      // eslint-disable-next-line no-empty
    } catch (_) {}
  }

  return dispatch({
    type: MERGE_OPERATION_DATA,
    payload: {
      selectPath: ['fingerprint'],
      data: { preflightState, preflightErrorKey: errorKey || '' },
    },
  });
};

export default fetchRiskPreflight;
